import React, { useEffect, useState } from 'react';
import { MatricsType } from '../../enums';
import { MATRICS } from '../../constants';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { Grid, TextField } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import clientUtils from '../../Utils/clientUtils';
import Matric from './Matric';

const defaultMatric = MATRICS[0];
const keyPairInitState = [
  {
    id: uuidv4(),
    keyItem: '',
    valueItem: '',
  },
];
const Matrics = () => {
  const [matrics, setMatrics] = useState(keyPairInitState);
  const [inputCounter, setInputCounter] = useState(1);
  const {
    register,
    getValues,
    setValue,
    formState: { errors },
  } = useFormContext();

  const onKeyPairAdd = () => {
    setMatrics((paneValue) => [
      ...paneValue,
      {
        id: uuidv4(),
        keyItem: MatricsType.Other,
        valueItem: MatricsType.Other,
      },
    ]);
  };

  const onKeyPairRemove = (keyPair) => {
    let newKeyValues = [...matrics];
    newKeyValues = newKeyValues.filter((x) => x.id !== keyPair.id);
    setMatrics(newKeyValues);
  };
  const onKeyPairUpdate = (keyPair) => {
    const elementIndex = matrics.findIndex((element) => element.id === keyPair.id);
    if (elementIndex > -1) {
      let newKeyValues = [...matrics];
      newKeyValues[elementIndex] = {
        ...newKeyValues[elementIndex],
        keyItem: keyPair.keyItem,
        valueItem: keyPair.valueItem,
      };
    
      if (!getValues('performanceStats.metrics')) {
        setValue('performanceStats.metrics', {});
      }
      const matrictDict = getValues('performanceStats.metrics');
      if (keyPair && keyPair.keyItem !== '' && matrictDict && matrictDict[keyPair.keyItem] !== 'undefined') {
        setValue('performanceStats.metrics', clientUtils.convertKeyValueToObject(newKeyValues));
      }
      setMatrics(newKeyValues);
    }
  };
  useEffect(() => {
    const newMatrics = getValues('performanceStats.metrics');
    let list = [];
    for (let matric in newMatrics) {
      const newMatric = {
        id: uuidv4(),
        keyItem: matric,
        valueItem: newMatrics[matric],
      };
      list.push(newMatric);
    }
    if (list.length > 0) {
      setMatrics(list);
    }
  }, []);

  const renderedList = matrics.map((keyPair, index) => {
    // console.log('keyPair', keyPair);
    return (
      <Matric
        key={keyPair.id}
        keyPair={keyPair}
        setKeyPair={(keyPairValue) => onKeyPairUpdate(keyPairValue)}
        onKeyPairRemove={() => onKeyPairRemove(keyPair)}
        items={matrics}
        index={index}
        onKeyPairAdd={onKeyPairAdd}
      />
    );
  });
  return <>{renderedList}</>;
};

export default Matrics;
